import { render, staticRenderFns } from "./waybillArchived.vue?vue&type=template&id=795a3204&scoped=true"
import script from "./waybillArchived.vue?vue&type=script&lang=js"
export * from "./waybillArchived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a3204",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('795a3204')) {
      api.createRecord('795a3204', component.options)
    } else {
      api.reload('795a3204', component.options)
    }
    module.hot.accept("./waybillArchived.vue?vue&type=template&id=795a3204&scoped=true", function () {
      api.rerender('795a3204', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/expressAndlargOrder/component/waybillArchived.vue"
export default component.exports